interface ModalProps {
  onClick?: any
  tall?: boolean
  children: React.ReactNode
}

const Modal: React.FunctionComponent<ModalProps> = ({
  onClick,
  tall,
  children
}) => {
  return (
    <div className='bg-black flex justify-center items-center'>
      <div className='glow-effect'>
        <div className='diamond-corner p-[4px] bg-dopage-lightGreen min-h-[400px] min-w-[670px] w-full '>
          <div className={`${tall === true ? 'min-h-768:h-[750px] min-h-1024:h-[820px]' : ''} inner bg-black h-[580px]`}>
            <div className='p-[22px] flex flex-col items-center text-dopage-lightGreen h-full'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
